"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DeskingQuestionsModel = _interopRequireDefault(require("../models/DeskingQuestionsModel"));

var _VehicleCondition = _interopRequireDefault(require("./VehicleCondition/VehicleCondition"));

// const questionsNotCounted = [
//     CORPORATE_USE_EXPLANATION,
//     COVERAGE_BALANCE,
//     TRUE_DISTANCE_TRAVELED,
//     CLARIFY_ACCIDENT,
//     CLARIFY_OPEN_NOTICES,
//     NEED_REPARATION_OTHER_EXPLANATION,
//     CLARIFY_DAMAGE,
//     CLARIFY_REGISTRY
// ];
var DeskingConditionForm = function DeskingConditionForm(props) {
  return /*#__PURE__*/_react.default.createElement(_VehicleCondition.default, (0, _extends2.default)({
    Model: (0, _typeof2.default)(props.model) === 'object' ? props.model : _DeskingQuestionsModel.default
  }, props));
};

DeskingConditionForm.propTypes = {
  model: _propTypes.default.object
};
var _default = DeskingConditionForm;
exports.default = _default;